var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProfilePoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E3F7F2",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00C2C2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.955 22.33c-3.703 0-5.285-1.582-5.285-5.285v-4.09c0-3.703 1.582-5.285 5.285-5.285h4.09c3.703 0 5.285 1.582 5.285 5.285v4.09c0 3.703-1.582 5.285-5.285 5.285h-4.09zm-4.262-9.375v4.09c0 3.144 1.118 4.262 4.262 4.262h4.09c3.144 0 4.262-1.118 4.262-4.262v-4.09c0-3.144-1.118-4.262-4.262-4.262h-4.09c-3.144 0-4.262 1.118-4.262 4.262z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 17.591a.514.514 0 0 1 0-.723l4.466-4.466a.514.514 0 0 1 .722 0 .514.514 0 0 1 0 .723l-4.465 4.466a.506.506 0 0 1-.362.15.506.506 0 0 1-.361-.15z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.59 13.043c0-.743.608-1.35 1.35-1.35.744 0 1.35.607 1.35 1.35 0 .743-.606 1.35-1.35 1.35-.742 0-1.35-.607-1.35-1.35zm1.024.007c0 .184.143.327.327.327a.323.323 0 0 0 .327-.327.327.327 0 0 0-.654 0zM15.7 16.85c0-.743.607-1.35 1.35-1.35.743 0 1.35.607 1.35 1.35 0 .743-.607 1.35-1.35 1.35-.743 0-1.35-.607-1.35-1.35zm1.023.007c0 .184.143.327.327.327a.323.323 0 0 0 .327-.327.323.323 0 0 0-.327-.327.327.327 0 0 0-.327.327z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfilePoints);
export default __webpack_public_path__ + "static/media/ic_profile_points.25d213e5ded0e1b95112cf914701dfb0.svg";
export { ForwardRef as ReactComponent };